import { activateTab, setEventHandlerAndScroll } from '../../util';
import { ACTIVE_WRAP_CLASS, ACTIVE_ITEMS_CLASS } from '../../constant';

export default class Depth4 {
    private $depth4Tab = document.querySelector<HTMLDivElement>('.depth4-tab');
    private $depth4TabListItems =
        document.querySelectorAll<HTMLLIElement>('.depth4-list-items');
    private $depth4ActivatedList: HTMLUListElement | null = null;
    // depth3, depth4 활성화된 탭 찾기 위한 index
    private depth4ActivatedSubTabIndex: number = -1; // 활성화된 뎁스4 리스트의 Index
    private $depth4ActivatedTab: HTMLLIElement | null = null;

    public activeTab(
        activateTabForDepth3: (compareUrl?: string) => void
    ): void {
        if (!this.$depth4Tab) return;
        activateTab(
            this.$depth4TabListItems,
            (depth4Element: HTMLLIElement, index: number) =>
                this._activeDepth4(depth4Element, index, activateTabForDepth3)
        );
    }
    private _activeDepth4 = (
        depth4Element: HTMLLIElement,
        index: number,
        activateTabForDepth3: (compareUrl?: string) => void
    ): void => {
        // 활성화된 탭 selected
        depth4Element.classList.add(ACTIVE_ITEMS_CLASS);
        this.$depth4ActivatedTab = depth4Element;
        this.depth4ActivatedSubTabIndex = index;

        const $depth4Wrap =
            depth4Element.closest<HTMLDivElement>('.depth4-list-wrap')!;
        $depth4Wrap.classList.add(ACTIVE_WRAP_CLASS);
        this.$depth4ActivatedList =
            $depth4Wrap.closest<HTMLUListElement>('.depth4-list');
        // depth3 탭을 data-url로 찾음
        activateTabForDepth3($depth4Wrap.getAttribute('data-url') || '');
    };
    // scroll, resize 이벤트 등록
    public setDepthEvent(): void {
        if (
            !this.$depth4Tab ||
            !this.$depth4ActivatedList ||
            !this.$depth4ActivatedTab
        )
            return;
        setEventHandlerAndScroll(
            this.$depth4ActivatedList,
            this.$depth4ActivatedTab,
            this.depth4ActivatedSubTabIndex
        );
    }
}
